module.exports = __webpack_public_path__ + "static/lotus_purple-2a16c0797056c02a7abc2e39de4fe9a5.png";